<div class="dialog-wrapper">
  <mat-dialog-actions class="top-close">
    <button
      mat-button
      mat-dialog-close
      class="button-link"
      [mat-dialog-close]="{ close: true }"
    >
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
          fill="red"
        />
      </svg>
    </button>
  </mat-dialog-actions>
  <form class="content-wrapper" *ngIf="fopData.length" [formGroup]="pagoForm">
    <div class="pago">
      <h2 mat-dialog-title>{{ 'OTRAS_FOP_TITLE' | translate | uppercase }}</h2>

      <ng-container *ngIf="fopData.length">
        <div class="pago-items">
          <!-- <div class="pago-item" *ngFor="let tipoDePago of fopData; let fopDataIndex = index"> -->
          <div class="pago-item">
            <div formArrayName="bankDetails" class="flex column gap-16">
              <div
                class="flex column gap-16"
                [formGroupName]="tipoDePagoIndex"
                *ngFor="
                  let pago of pagoForm.controls['bankDetails']['controls'];
                  let tipoDePagoIndex = index
                "
              >
                <div class="pago-item-inputs-wrapper flex-wrap">
                  <span class="pago-nombre mt-12">{{
                    pago.controls.title.value
                  }}</span>

                  <div class="flex column space-between gap-16">
                    <div class="flex gap-16 align-center flex-wrap">
                      <input
                        type="text"
                        autocomplete="off"
                        class="pago-input"
                        [placeholder]="dialogData.placeholderValue"
                        category="DIVISA"
                        #inputField
                        [formControlName]="controlNameEnum.FOP_PAGO"
                        (input)="
                          onInput(
                            $event,
                            controlNameEnum.FOP_PAGO,
                            tipoDePagoIndex,
                            null,
                            inputTypeEnum.NUMBER
                          )
                        "
                        (focus)="
                          focusInput(
                            $event,
                            controlNameEnum.FOP_PAGO,
                            tipoDePagoIndex
                          )
                        "
                        (blur)="
                          focusOutInput(
                            $event,
                            controlNameEnum.FOP_PAGO,
                            tipoDePagoIndex,
                            null,
                            'bankDetails.' +
                              tipoDePagoIndex +
                              '.' +
                              controlNameEnum.FOP_PAGO
                          )
                        "
                      />

                      <div
                        class="flex gap-16 align-center"
                        *ngIf="
                          pago.controls.fopPago.value &&
                          pago.controls.fopPago.valid
                        "
                      >
                        <button
                          mat-button
                          class="button-link button-add"
                          type="button"
                          (click)="addOtherFormPay(tipoDePagoIndex)"
                          *ngIf="pagoMultiple === '1'"
                        >
                          <mat-icon class="material-icons">add</mat-icon>
                        </button>

                        <div class="flex pago-bank-items gap-16">
                          <label
                            [for]="
                              controlNameEnum.FOP_PAGO_BANK_NUMBER +
                              tipoDePagoIndex
                            "
                          >
                            <input
                              type="text"
                              [id]="
                                controlNameEnum.FOP_PAGO_BANK_NUMBER +
                                tipoDePagoIndex
                              "
                              placeholder="{{ 'NUMERO' | translate }}"
                              autocomplete="off"
                              [formControlName]="
                                controlNameEnum.FOP_PAGO_BANK_NUMBER
                              "
                              class="pago-input"
                              category="DIVISA"
                              #inputField
                              maxlength="20"
                              (input)="
                                onInput(
                                  $event,
                                  controlNameEnum.FOP_PAGO_BANK_NUMBER,
                                  tipoDePagoIndex,
                                  null,
                                  inputTypeEnum.NUMBER
                                )
                              "
                              (focus)="
                                focusInput(
                                  $event,
                                  controlNameEnum.FOP_PAGO_BANK_NUMBER,
                                  tipoDePagoIndex
                                )
                              "
                            />
                            <span>{{ 'NUMERO' | translate }}</span>
                          </label>
                          <ng-container
                            *ngIf="
                              !pago.controls.title.value
                                .toLowerCase()
                                .includes('cult')
                            "
                          >
                            <label
                              [for]="
                                controlNameEnum.FOP_PAGO_BANK_NAME +
                                tipoDePagoIndex
                              "
                            >
                              <input
                                type="text"
                                [id]="
                                  controlNameEnum.FOP_PAGO_BANK_NAME +
                                  tipoDePagoIndex
                                "
                                placeholder="{{ 'NOMBRE_BANCO' | translate }}"
                                autocomplete="off"
                                maxlength="100"
                                [formControlName]="
                                  controlNameEnum.FOP_PAGO_BANK_NAME
                                "
                                class="pago-input"
                                category="DIVISA"
                                #inputField
                                (input)="
                                  onInput(
                                    $event,
                                    controlNameEnum.FOP_PAGO_BANK_NAME,
                                    tipoDePagoIndex,
                                    null,
                                    inputTypeEnum.TEXT
                                  )
                                "
                              />
                              <span>{{ 'NOMBRE_BANCO' | translate }}</span>
                            </label>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div
                      formArrayName="inputs"
                      class="flex column mb-16 gap-16"
                      *ngIf="pago.get('inputs').controls.length"
                    >
                      <form
                        class="pago-item-inputs"
                        [formGroupName]="inputIndex"
                        *ngFor="
                          let pagoChilds of pago.get('inputs').controls;
                          let inputIndex = index
                        "
                      >
                        <div
                          class="pago-item-inputs-wrapper align-center gap-16"
                        >
                          <input
                            type="text"
                            autocomplete="off"
                            class="pago-input"
                            [placeholder]="dialogData.placeholderValue"
                            category="DIVISA"
                            #inputField
                            [formControlName]="controlNameEnum.FOP_PAGO"
                            (input)="
                              onInput(
                                $event,
                                controlNameEnum.FOP_PAGO,
                                tipoDePagoIndex,
                                inputIndex,
                                inputTypeEnum.NUMBER
                              )
                            "
                            (focus)="
                              focusInput(
                                $event,
                                controlNameEnum.FOP_PAGO,
                                tipoDePagoIndex,
                                inputIndex
                              )
                            "
                            (blur)="
                              focusOutInput(
                                $event,
                                controlNameEnum.FOP_PAGO,
                                tipoDePagoIndex,
                                inputIndex,
                                'bankDetails.' +
                                  tipoDePagoIndex +
                                  '.inputs.' +
                                  inputIndex +
                                  '.' +
                                  controlNameEnum.FOP_PAGO
                              )
                            "
                          />
                          <button
                            mat-button
                            class="button-link button-remove"
                            type="button"
                            (click)="removeFormPay(tipoDePagoIndex, inputIndex)"
                          >
                            <mat-icon class="material-icons">close</mat-icon>
                          </button>

                          <div
                            class="pago-bank-items flex gap-16 align-center"
                            *ngIf="
                              pagoChilds.controls.fopPago.value &&
                              pagoChilds.controls.fopPago.valid
                            "
                          >
                            <div class="flex align-center gap-16">
                              <label
                                [for]="
                                  controlNameEnum.FOP_PAGO_BANK_NUMBER +
                                  inputIndex
                                "
                              >
                                <input
                                  type="text"
                                  [id]="
                                    controlNameEnum.FOP_PAGO_BANK_NUMBER +
                                    inputIndex
                                  "
                                  placeholder="{{ 'NUMERO' | translate }}"
                                  autocomplete="off"
                                  [formControlName]="
                                    controlNameEnum.FOP_PAGO_BANK_NUMBER
                                  "
                                  class="pago-input"
                                  category="DIVISA"
                                  #inputField
                                  maxlength="20"
                                  (input)="
                                    onInput(
                                      $event,
                                      controlNameEnum.FOP_PAGO_BANK_NUMBER,
                                      tipoDePagoIndex,
                                      inputIndex,
                                      inputTypeEnum.NUMBER
                                    )
                                  "
                                  (focus)="
                                    focusInput(
                                      $event,
                                      controlNameEnum.FOP_PAGO_BANK_NUMBER,
                                      tipoDePagoIndex,
                                      inputIndex
                                    )
                                  "
                                />
                                <span>{{ 'NUMERO' | translate }}</span>
                              </label>
                              <ng-container
                                *ngIf="
                                  !pago.controls.title.value
                                    .toLowerCase()
                                    .includes('cult')
                                "
                              >
                                <label
                                  [for]="
                                    controlNameEnum.FOP_PAGO_BANK_NAME +
                                    inputIndex
                                  "
                                >
                                  <input
                                    type="text"
                                    [id]="
                                      controlNameEnum.FOP_PAGO_BANK_NAME +
                                      inputIndex
                                    "
                                    placeholder="{{
                                      'NOMBRE_BANCO' | translate
                                    }}"
                                    maxlength="100"
                                    autocomplete="off"
                                    [formControlName]="
                                      controlNameEnum.FOP_PAGO_BANK_NAME
                                    "
                                    class="pago-input"
                                    category="DIVISA"
                                    #inputField
                                    (input)="
                                      onInput(
                                        $event,
                                        controlNameEnum.FOP_PAGO_BANK_NAME,
                                        tipoDePagoIndex,
                                        inputIndex,
                                        inputTypeEnum.TEXT
                                      )
                                    "
                                  />
                                  <span>{{ 'NOMBRE_BANCO' | translate }}</span>
                                </label>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div
      class="vacance"
      *ngIf="dialogData.checkVaccanceType === '1' && checkVacanceData.length"
    >
      <h2 mat-dialog-title>{{ 'CHEQUE_VACCANCES' | translate | uppercase }}</h2>

      <div class="vacance-items">
        <div
          class="vacance-item"
          *ngFor="let vacance of checkVacanceData; let vaccanceIndex = index"
        >
          <span
            (click)="
              addCantidadVacance(
                vacance.pkId + controlNameEnum.VACANCE,
                inputField.value
              )
            "
            >{{
              vacance.valor
                | myCurrency
                  : dialogData.divisaSimboloDecimal
                  : dialogData.divisaDecimales
                  : dialogData.divisaPosicion
                  : dialogData.divisaSimbolo
                  : dialogData.divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}</span
          >
          <!-- (focus)="focusInput($event, vacance.pkId + controlNameEnum.VACANCE)" -->
          <input
            type="text"
            autocomplete="off"
            class="vacance-input"
            placeholder="0"
            category="DIVISA"
            #inputField
            [formControlName]="vacance.pkId + controlNameEnum.VACANCE"
            (input)="
              onVacanseInput(
                $event.target.value,
                vacance.pkId + controlNameEnum.VACANCE
              )
            "
            (focus)="focusInput($event, vacance.pkId + controlNameEnum.VACANCE)"
          />
        </div>
      </div>

      <div class="vacance-total">
        <span class="vacance-total-title">{{ 'TOTAL' | translate }}</span>
        <span class="vacance-total-sum">{{
          checkVacanceTotalValue
            | myCurrency
              : dialogData.divisaSimboloDecimal
              : dialogData.divisaDecimales
              : dialogData.divisaPosicion
              : dialogData.divisaSimbolo
              : dialogData.divisaSimboloDerecha
              : divisaSimbSeparacionMiles
        }}</span>
        <button
          class="vacance-total-button"
          (click)="confirmVacanse()"
          [disabled]="isConfirmBtnVacanseDisabled"
          type="button"
        >
          {{ 'CONFIRMAR' | translate }}
        </button>
      </div>
    </div>

    <div class="total">
      <!-- <ticketing-modal-pago-total></ticketing-modal-pago-total> -->
      <div class="total-selected">
        <div
          class="total-selected-item"
          *ngFor="let fop of totalData; let selectedIndex = index"
        >
          <span>{{ fop.nombre | translate }}</span>
          <div class="flex align-center gap-8">
            <span>{{
              fop.value
                | myCurrency
                  : dialogData.divisaSimboloDecimal
                  : dialogData.divisaDecimales
                  : dialogData.divisaPosicion
                  : dialogData.divisaSimbolo
                  : dialogData.divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}</span>
            <button
              mat-button
              class="button-link"
              type="button"
              (click)="removeSelectedPago(fop.pkId, selectedIndex)"
            >
              <mat-icon class="material-icons button-remove">close</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="total-resume-wrapper">
        <div class="total-resume">
          <div class="total-resume-item">
            <span>{{ 'TOTAL' | translate }}</span>
            <span>{{
              total
                | myCurrency
                  : dialogData.divisaSimboloDecimal
                  : dialogData.divisaDecimales
                  : dialogData.divisaPosicion
                  : dialogData.divisaSimbolo
                  : dialogData.divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}</span>
          </div>
          <div class="total-resume-item">
            <span>{{ 'RECIBIDO' | translate }}</span>
            <span>{{
              recibido
                | myCurrency
                  : dialogData.divisaSimboloDecimal
                  : dialogData.divisaDecimales
                  : dialogData.divisaPosicion
                  : dialogData.divisaSimbolo
                  : dialogData.divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}</span>
          </div>
          <div class="total-resume-item">
            <span>{{ 'DIFERENCIA' | translate }}</span>
            <span>{{
              diferencia
                | myCurrency
                  : dialogData.divisaSimboloDecimal
                  : dialogData.divisaDecimales
                  : dialogData.divisaPosicion
                  : dialogData.divisaSimbolo
                  : dialogData.divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}</span>
          </div>
        </div>

        <ticketing-numpad></ticketing-numpad>
        <mat-dialog-actions class="total-btns">
          <button
            class="button-link total-btns-cancel"
            mat-button
            mat-dialog-close
            (click)="cancelAll()"
          >
            {{ 'CANCELAR' | translate }}
          </button>
          <button
            [disabled]="
              (pagoMultiple !== '1' && recibido < dialogData.precioTotal) ||
              (pagoMultiple !== '1' && totalData.length > 1) ||
              (pagoMultiple === '1' && recibido === 0)
            "
            class="button-link total-btns-accept"
            mat-button
            mat-dialog-close
            (click)="acceptAll()"
            cdkFocusInitial
          >
            {{ 'ACEPTAR' | translate }}
          </button>
        </mat-dialog-actions>
      </div>
    </div>
  </form>
</div>
